import * as React from "react"

const StickyHeader = () => {

  return (
    <div className='fixed z-10 top-0 w-full'>
        <div className=' w-full p-4 flex flex-col items-center justify-center text-center text-white font-vef font-semibold'>
            <div className='text-5xl'>VIET ECOLOGY FOUNDATION</div>
            <div className='text-3xl py-3'>Mekong River Sentinel</div>
        </div>
    </div>
  )
}

export default StickyHeader;
